export const GLOBAL_QUERY_ERROR_HANDLING_META = 'globalQueryErrorHandling';

export const GLOBAL_QUERY_ERROR_REAUTHENTICATION_ONLY = 'reauthenticationOnly';

export const shouldHandleGlobalQueryError = (
  meta?: Record<string, unknown>
): boolean =>
  meta?.[GLOBAL_QUERY_ERROR_HANDLING_META] !== false &&
  meta?.[GLOBAL_QUERY_ERROR_HANDLING_META] !==
    GLOBAL_QUERY_ERROR_REAUTHENTICATION_ONLY;

export const shouldHandleGlobalQueryReauthentication = (
  meta?: Record<string, unknown>
): boolean => meta?.[GLOBAL_QUERY_ERROR_HANDLING_META] !== false;

export const shouldHandleGlobalMutationReauthentication =
  shouldHandleGlobalQueryReauthentication;
